import { FC, ReactNode, useRef } from "react";
import cn from "classnames";
import styles from "./Radio.module.sass";

interface RadioProps {
	label?: string | ReactNode;
	checked?: boolean;
	name: string;
	value: string;
	handleSelected: (value: any) => void;
	className?: string;
}

const Radio: FC<RadioProps> = ({ label, checked, name, value, handleSelected, className, ...props }) => {
	const inputRef = useRef<any>(null);

	const clickHandler = (e: any) => {
		e.preventDefault();
		if (inputRef.current) inputRef.current.checked = true;
		handleSelected(value);
	};

	return (
		<label onClick={clickHandler} className={cn(styles.radio, className)}>
			<div>
				<input
					ref={inputRef}
					type="radio"
					className={styles.input}
					name={name}
					value={value}
					checked={checked}
					onChange={() => handleSelected(value)}
					{...props}
				/>

				<span className={styles.fake} />
			</div>

			{label && <span className={styles.label}>{label}</span>}
		</label>
	);
};

export default Radio;
